import { ChatWidgetStore } from '@/widget/services/useChatWidgetStore';
import { snakeCaseKeys } from '@/lib/objects';

function sendContactForm({
  conversationKey, formData, subscription,
}: {
  conversationKey: string;
  formData: object;
  subscription: ActionCable.Channel;
}): boolean {
  return subscription.send({
    action_name: 'process_contact_form',
    payload: snakeCaseKeys({
      conversationKey,
      formData,
    }),
  });
}

function setContact({
  contactId, store,
} : {
  contactId: string;
  store: ChatWidgetStore;
}) {
  const { setContactId } = store.getState();
  const id = parseInt(contactId, 10);
  setContactId(id);
}

const ContactDispatcher = {
  sendContactForm,
  setContact,
};

export default ContactDispatcher;
